const UPDATES = [
  {
    id: 1,
    date: '07-29',
    title: '《重生之都市修仙》第358话更新',
    desc: '最新章节「仙尊归来」已上线，下拉式阅读即刻体验',
    tag: '国漫更新',
    tagColor: 'bg-red-50 text-red-600',
  },
  {
    id: 2,
    date: '07-29',
    title: '《霸道总裁的契约新娘》第212话',
    desc: '契约婚姻真相大白，剧情迎来重大转折',
    tag: '韩漫更新',
    tagColor: 'bg-pink-50 text-pink-600',
  },
  {
    id: 3,
    date: '07-28',
    title: '《咒术回战·外传》第89话更新',
    desc: '咒术师与特级诅咒的终极对决正式打响',
    tag: '日漫更新',
    tagColor: 'bg-amber-50 text-amber-600',
  },
  {
    id: 4,
    date: '07-28',
    title: '平台新增300+部韩漫全集资源',
    desc: '热门韩漫全集一次性上线，涵盖恋爱重生都市等多品类',
    tag: '资源上新',
    tagColor: 'bg-green-50 text-green-600',
  },
  {
    id: 5,
    date: '07-27',
    title: '《财阀家的小儿子》第156话上线',
    desc: '财阀继承权争夺进入白热化阶段',
    tag: '韩漫更新',
    tagColor: 'bg-pink-50 text-pink-600',
  },
  {
    id: 6,
    date: '07-27',
    title: '国漫专区「古风仙侠」板块重磅上线',
    desc: '收录《仙王的日常生活》等优质国漫，下拉式阅读体验升级',
    tag: '功能上新',
    tagColor: 'bg-teal-50 text-teal-600',
  },
  {
    id: 7,
    date: '07-26',
    title: '《我在诡异世界当NPC》第67话',
    desc: '诡异世界规则揭晓，主角身世之谜浮出水面',
    tag: '国漫更新',
    tagColor: 'bg-red-50 text-red-600',
  },
  {
    id: 8,
    date: '07-26',
    title: '追更提醒功能优化，更新推送更及时',
    desc: '收藏漫画更新后第一时间通知，不错过任何精彩章节',
    tag: '体验优化',
    tagColor: 'bg-sky-50 text-sky-600',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">更新快讯</h2>
          <p className="text-sm text-foreground-600">
            最新漫画更新动态与平台资讯，追更不迷路
          </p>
        </div>

        <div className="relative pl-6 md:pl-8 border-l-2 border-background-200 space-y-6">
          {UPDATES.map((item) => (
            <div key={item.id} className="relative">
              <div className="absolute -left-[27px] md:-left-[33px] top-1 w-3 h-3 rounded-full bg-primary-400 border-2 border-background-50"></div>
              <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                <span className="text-xs font-medium text-foreground-400 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap flex-shrink-0 w-fit">
                  {item.date}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                    <span className={`text-xs px-1.5 py-0.5 rounded-full ${item.tagColor} whitespace-nowrap`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}